import { render } from "./Tournaments.vue?vue&type=template&id=4a3d073c&ts=true"
import script from "./Tournaments.vue?vue&type=script&lang=ts"
export * from "./Tournaments.vue?vue&type=script&lang=ts"

import "./Tournaments.vue?vue&type=style&index=0&id=4a3d073c&lang=css"

import exportComponent from "/builds/clickfun/frontend/clickfun_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__